import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import moment from 'moment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lambdaSettings: {
      url: '',
      testStage: 'https://tscgpa0196.execute-api.us-west-2.amazonaws.com/test/',
      prodStage:
        'https://tscgpa0196.execute-api.us-west-2.amazonaws.com/production/',
    },
    loggedInUser: null,
    companyId: null,
    companyName: null,
    users: {},
    clients: {},
    projects: {},
    tasks: {},
    timeSubmissions: {},
    expenseSubmissions: {},
    serviceTypes: {},
    currentWeek: [
      moment()
        .startOf('month')
        .format('YYYY-MM-DD'),
      moment()
        .endOf('month')
        .format('YYYY-MM-DD'),
    ],
    standardUserViews: ['Dashboard', 'Projects'],
    adminUserViews: ['Dashboard', 'Projects', 'Team', 'Settings', 'Analytics'],
  },
  getters: {
    environment() {
      if (
        !window.location.host.toLowerCase().includes('test') &&
        !window.location.host.toLowerCase().includes('localhost')
      ) {
        return 'production'
      } else {
        return 'test'
      }
    },
    lambdaUrl(state, getters) {
      if (getters.environment == 'production') {
        return state.lambdaSettings.url + state.lambdaSettings.prodStage
      } else if (getters.environment == 'test') {
        return state.lambdaSettings.url + state.lambdaSettings.testStage
      }
    },
    getUsers(state) {
      return state.users
    },
    getPagePermission(state) {
      if (state.loggedInUser.type == 'Admin') {
        return state.adminUserViews
      } else {
        return state.standardUserViews
      }
    },
    getClients(state) {
      return state.clients
    },
    getProjects(state) {
      return state.projects
    },
    getServiceTypes(state) {
      return state.serviceTypes
    },
    getTasks(state) {
      return state.tasks
    },
    getTimeSubmissions(state) {
      return state.timeSubmissions
    },
    getExpenseSubmissions(state) {
      return state.expenseSubmissions
    },
    getLoggedInUser(state) {
      return state.loggedInUser
    },
    getCompanyId(state) {
      return state.companyId
    },
    getCompanyName(state) {
      return state.companyName
    },
    getCurrentWeek(state) {
      return state.currentWeek
    },
  },
  mutations: {
    updateTable(state, payload) {
      let object = null
      switch (payload.object) {
        case 'project':
          object = state.projects
      }
      if (payload.action == 'add' || payload.action == 'edit') {
        object[payload.item.id] = payload.item
      } else if (payload.action == 'delete') {
        delete object[payload.item]
      }
    },
    teamMemberEdited(state, payload) {
      state.users[payload.id] = payload
    },
    teamMemberDeleted(state, payload) {
      delete state.users[payload.id]
    },
    updateUsers(state, payload) {
      state.users = payload
    },
    updateServiceTypes(state, payload) {
      state.serviceTypes = payload
    },
    clearUser(state) {
      state.clients = {}
      state.projects = {}
      state.users = {}
      state.serviceTypes = {}
      state.loggedInUser = null
    },
    updateInitialData(state, [user, payload]) {
      state.companyId = payload.companyData.id
      state.clients = payload.clients
      state.projects = payload.projects
      state.users = payload.users
      state.serviceTypes = payload.serviceTypes
      state.tasks = payload.tasks
      state.timeSubmissions = payload.timeSubmissions
      state.expenseSubmissions = payload.expenseSubmissions
      const u = payload.user
      u.token = user ? user.signInUserSession.idToken.jwtToken : null
      state.loggedInUser = u
      // eslint-disable-next-line no-console
      console.log('Logged in user:', state.loggedInUser)
    },
    updateClients(state, payload) {
      state.clients = payload
    },
    updateClientBalances(state, payload) {
      state.clients[payload.clientId].balance =
        parseFloat(state.clients[payload.clientId].balance) +
        parseFloat(payload.amount)
      if (payload.paymentMethod == 'Account Credit') {
        state.clients[payload.clientId].credits =
          parseFloat(state.clients[payload.clientId].credits) +
          parseFloat(payload.amount)
      } else {
        state.clients[payload.clientId].payments =
          parseFloat(state.clients[payload.clientId].payments) +
          parseFloat(payload.amount)
      }
    },
    updateClient(state, payload) {
      state.clients[payload.id] = payload
    },
    deleteClient(state, payload) {
      Vue.delete(state.clients, payload)
    },
    addServiceType(state, payload) {
      state.serviceTypes[payload.id] = payload
    },
    updateTimeSubmission(state, payload) {
      state.timeSubmissions[payload.id] = payload
    },
    updateProjectTaskTotals(state, payload) {
      if (payload.changedData.changedHours != null) {
        state.projects[payload.projectId].hours =
          parseFloat(state.projects[payload.projectId].hours) +
          parseFloat(payload.changedData.changedHours)
        state.projects[payload.projectId].billedLabor =
          parseFloat(state.projects[payload.projectId].billedLabor) +
          parseFloat(payload.changedData.changedBillableLabor)
        state.tasks[payload.taskId].hours =
          parseFloat(state.tasks[payload.taskId].hours) +
          parseFloat(payload.changedData.changedHours)
        state.tasks[payload.taskId].billedLabor =
          parseFloat(state.tasks[payload.taskId].billedLabor) +
          parseFloat(payload.changedData.changedBillableLabor)
      }
      if (payload.changedData.changedCost != null) {
        state.projects[payload.projectId].expenses =
          parseFloat(state.projects[payload.projectId].expenses) +
          parseFloat(payload.changedData.changedCost)
        state.projects[payload.projectId].billedExpenses =
          parseFloat(state.projects[payload.projectId].billedExpenses) +
          parseFloat(payload.changedData.changedBilledAmount)
        state.tasks[payload.taskId].expenses =
          parseFloat(state.tasks[payload.taskId].expenses) +
          parseFloat(payload.changedData.changedCost)
        state.tasks[payload.taskId].billedExpenses =
          parseFloat(state.tasks[payload.taskId].billedExpenses) +
          parseFloat(payload.changedData.changedBilledAmount)
      }
    },
    deleteTimeSubmission(state, payload) {
      Vue.delete(state.timeSubmissions, payload)
    },
    updateExpenseSubmission(state, payload) {
      state.expenseSubmissions[payload.id] = payload
    },
    deleteExpenseSubmission(state, payload) {
      Vue.delete(state.expenseSubmissions, payload)
    },
    updateProject(state, payload) {
      state.projects[payload.id] = payload
    },
    deleteProject(state, payload) {
      Vue.delete(state.projects, payload)
    },
    updateProjects(state, payload) {
      for (var projectId in payload) {
        let expenseMarkup =
          payload[projectId].expenseMarkup != null
            ? payload[projectId].expenseMarkup
            : 0
        payload[projectId].billedExpenses =
          payload[projectId].expenses + expenseMarkup
      }
      state.projects = payload
    },
    updateCompany(state, payload) {
      state.companyId = payload.id
      state.companyName = payload.name
    },
  },
  actions: {
    addTeamMember(context, incomingPayload) {
      incomingPayload.companyName = context.getters.getCompanyName
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'adduser',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: incomingPayload || {},
      })
        .then(response => {
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    editUser(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'edituser',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: {
          action: 'edit',
          userId: incomingPayload.userId,
          dataToEdit: incomingPayload.changedData,
        },
      })
        .then(response => {
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    deleteUser(context, userId) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'edituser',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: {
          action: 'delete',
          userId: userId,
          dataToEdit: {},
        },
      })
        .then(response => {
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    clearUser(context) {
      context.commit('clearUser')
    },
    async setUser(context, user) {
      if (user == null) {
        user = await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
      }

      if (user != null) {
        return axios({
          method: 'post',
          url: context.getters.lambdaUrl + 'initialdataload',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}`,
          },
          data: {
            email: user.attributes.email,
            companyName: context.state.companyName,
            currentWeek: context.state.currentWeek,
          },
        })
          .then(response => {
            if (response.data.success == true) {
              context.commit('updateInitialData', [user, response.data.data])
            }
            return response.data
          })
          .catch(error => {
            return error
          })
      }
    },
    getTeamMembers(context, incomingPayload) {
      // eslint-disable-next-line no-console
      console.log(context.state.loggedInUser)
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'getusers',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: incomingPayload || {} || {},
      })
        .then(response => {
          if (response.data.success == true) {
            context.commit('updateUsers', response.data.data)
          }
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    addClient(context, incomingPayload) {
      incomingPayload.companyId = context.getters.getCompanyId
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'addclient',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: incomingPayload || {},
      })
        .then(response => {
          context.commit('updateClient', response.data.data)
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    editClient(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'editclient',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: {
          action: 'edit',
          clientId: incomingPayload.clientId,
          dataToEdit: incomingPayload.changedData,
        },
      })
        .then(response => {
          if (response.data.success == true) {
            context.commit('updateClient', response.data.data.Attributes)
          }
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    deleteClient(context, clientId) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'editclient',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: {
          action: 'delete',
          clientId: clientId,
          dataToEdit: {},
        },
      })
        .then(response => {
          if (response.data.success == true) {
            context.commit('deleteClient', clientId)
          }
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    getClients(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'getclients',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: incomingPayload || {},
      })
        .then(response => {
          if (response.data.success == true) {
            context.commit('updateClients', response.data.data)
          }
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    getCompanyData(context, name) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'getcompany',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: { name: name },
      })
        .then(response => {
          if (response.data.success == true) {
            context.commit('updateCompany', response.data.data)
          }
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    addProject(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'addproject',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: incomingPayload || {},
      })
        .then(response => {
          context.commit('updateProject', response.data.data)
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    editProject(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'editproject',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: {
          action: 'edit',
          projectId: incomingPayload.projectId,
          dataToEdit: incomingPayload.changedData,
        },
      })
        .then(response => {
          if (response.data.success == true) {
            context.commit('updateProject', response.data.data.Attributes)
          }
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    deleteProject(context, projectId) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'editproject',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: {
          action: 'delete',
          projectId: projectId,
          dataToEdit: {},
        },
      })
        .then(response => {
          if (response.data.success == true) {
            context.commit('deleteProject', projectId)
          }
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    getProjects(context) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'getprojects',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: { companyId: context.getters.getCompanyId },
      })
        .then(response => {
          if (response.data.success == true) {
            context.commit('updateProjects', response.data.data)
          }
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    submitTask(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'submittask',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: incomingPayload || {},
      })
        .then(response => {
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    editTask(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'edittask',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: {
          action: 'edit',
          id: incomingPayload.id,
          dataToEdit: incomingPayload.changedData,
        },
      })
        .then(response => {
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    deleteTask(context, taskId) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'editTask',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: {
          action: 'delete',
          taskId: taskId,
          dataToEdit: {},
        },
      })
        .then(response => {
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    submitTime(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'submittime',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: incomingPayload || {},
      })
        .then(response => {
          let projectTaskTotalData = {
            changedData: {
              changedBillableLabor:
                incomingPayload.rate * incomingPayload.duration,
              changedHours: incomingPayload.duration,
            },
            projectId: incomingPayload.projectId,
            taskId: incomingPayload.taskId,
          }
          context.commit('updateTimeSubmission', response.data.data)
          context.commit('updateProjectTaskTotals', projectTaskTotalData)
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    editTimeSubmission(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'edittimesubmission',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: {
          action: 'edit',
          id: incomingPayload.id,
          dataToEdit: incomingPayload.changedData,
          projectId: incomingPayload.projectId,
          taskId: incomingPayload.taskId,
        },
      })
        .then(response => {
          context.commit('updateTimeSubmission', response.data.data.Attributes)
          context.commit('updateProjectTaskTotals', incomingPayload)
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    deleteTimeSubmission(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'edittimesubmission',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: {
          action: 'delete',
          id: incomingPayload.id,
          dataToEdit: incomingPayload.changedData,
          taskId: incomingPayload.taskId,
          projectId: incomingPayload.projectId,
        },
      })
        .then(response => {
          context.commit('deleteTimeSubmission', incomingPayload.id)
          context.commit('updateProjectTaskTotals', incomingPayload)
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    editExpenseSubmission(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'editexpensesubmission',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: {
          action: 'edit',
          id: incomingPayload.id,
          dataToEdit: incomingPayload.changedData,
          projectId: incomingPayload.projectId,
          taskId: incomingPayload.taskId,
        },
      })
        .then(response => {
          context.commit(
            'updateExpenseSubmission',
            response.data.data.Attributes
          )
          context.commit('updateProjectTaskTotals', incomingPayload)
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    deleteExpenseSubmission(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'editexpensesubmission',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: {
          action: 'delete',
          id: incomingPayload.id,
          dataToEdit: incomingPayload.changedData,
          taskId: incomingPayload.taskId,
          projectId: incomingPayload.projectId,
        },
      })
        .then(response => {
          context.commit('deleteExpenseSubmission', incomingPayload.id)
          context.commit('updateProjectTaskTotals', incomingPayload)
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    recalculateProject(context, projectId) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'recalculateproject',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: {
          projectId: projectId,
        },
      })
        .then(response => {
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    submitExpense(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'submitexpense',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: incomingPayload || {},
      })
        .then(response => {
          let projectTaskTotalData = {
            changedData: {
              changedCost: incomingPayload.cost,
              changedBilledAmount: incomingPayload.billedAmount,
            },
            projectId: incomingPayload.projectId,
            taskId: incomingPayload.taskId,
          }
          context.commit('updateExpenseSubmission', response.data.data)
          context.commit('updateProjectTaskTotals', projectTaskTotalData)
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    submitPayment(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'submitpayment',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: incomingPayload || {},
      })
        .then(response => {
          context.commit('updateClientBalances', response.data.data)

          return response.data
        })
        .catch(error => {
          return error
        })
    },
    getTasks(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'gettasks',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: incomingPayload || {},
      })
        .then(response => {
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    addServiceType(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'addservicetype',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: incomingPayload || {},
      })
        .then(response => {
          if (response.data.success == true) {
            context.commit('addServiceType', response.data.data)
          }
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    getServiceTypes(context) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'getservicetype',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: { companyId: context.getters.getCompanyId },
      })
        .then(response => {
          if (response.data.success == true) {
            context.commit('updateServiceTypes', response.data.data)
          }
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    getTimeSubmissions(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'gettimesubmissions',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: incomingPayload || {},
      })
        .then(response => {
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    getExpenseSubmissions(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'getexpensesubmissions',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: incomingPayload || {},
      })
        .then(response => {
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    getPaymentSubmissions(context, incomingPayload) {
      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'getpaymentsubmissions',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: incomingPayload || {},
      })
        .then(response => {
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    getPresignedUrl(context, incomingPayload) {
      incomingPayload.bucket = 'caddyworkflow-uploads'
      incomingPayload.path =
        context.getters.environment + '/' + incomingPayload.path

      return axios({
        method: 'post',
        url: context.getters.lambdaUrl + 'getpresignedurl',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${context.state.loggedInUser.token}`,
        },
        data: incomingPayload || {},
      })
        .then(response => {
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    uploadFileToS3(context, incomingPayload) {
      const base64String = incomingPayload.fileBody.split('base64,')[1]
      const buff = new Buffer(base64String, 'base64')
      let options = {
        method: 'put',
        url: incomingPayload.presignedUrl,
        headers: {
          'Content-Type': incomingPayload.contentType,
          'Content-Encoding': 'base64',
        },
        data: buff,
      }

      return axios(options)
        .then(response => {
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    getS3ImageBody(context, incomingPayload) {
      return axios({
        method: 'GET',
        url: incomingPayload.s3ImageUrl,
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': incomingPayload.s3ImageContentType,
        },
      })
        .then(response => {
          return (
            'data:' +
            incomingPayload.s3ImageContentType +
            ';base64,' +
            Buffer.from(response.data, 'binary').toString('base64')
          )
        })
        .catch(error => {
          return error
        })
    },
  },
  modules: {},
})
